/* eslint max-len: 0 */
import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'md-employmentFactory',
  template: require('./employmentFactory.component.html')
})

export class EmploymentfactoryComponent {
  @Input() inputFields;
  @Input() showUp;
  @Output() valueChange = new EventEmitter();

  updateOptionValue(event) {
    this.valueChange.emit(event);
  }

  formBtnClicked(event) {
    this.valueChange.emit(event);
  }
}
